import React from 'react';
import { TableBodyItem } from './Table.styles';

const TableItem = ({ data, className, image, onClickInfo }) => {
  return (
    <TableBodyItem className={className} onClick={onClickInfo}>
      {data}
    </TableBodyItem>
  );
};

export default TableItem;
